import React from 'react';
import { Autosuggest } from '@amzn/awsui-components-react/polaris';
import CONSTANTS from 'src/utils/constants';

/** Max suggestions rendered at once — the currency code list is long. */
const MAX_SUGGESTIONS = 50;

/**
 * Single-value currency autosuggest shared by the GL Balance Pull and Manual column forms.
 * `options` is the loaded currency-code LOV (STAT is added here). Suggestions are shown only once the
 * user starts typing (manual filtering, capped) so clicking the empty field does not dump the full
 * list. The parent still owns the LOV fetch (so it can build the valid-currency set for validation).
 */
export default function CurrencyAutosuggest(props: {
    options: string[];
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}) {
    const { options, value, onChange, placeholder } = props;

    const query = (value ?? '').trim().toLowerCase();
    const suggestions =
        query.length === 0
            ? []
            : [CONSTANTS.STAT_CURRENCY, ...(options ?? [])]
                  .filter((c) => c.toLowerCase().includes(query))
                  .slice(0, MAX_SUGGESTIONS)
                  .map((c) => ({ value: c }));

    return (
        <Autosuggest
            value={value ?? ''}
            options={suggestions}
            filteringType="manual"
            onChange={({ detail }) => onChange(detail.value)}
            enteredTextLabel={(v) => `Use "${v}"`}
            placeholder={placeholder ?? 'e.g. STAT'}
            empty={query.length === 0 ? 'Type to search' : 'No matches found'}
        />
    );
}
